/**
 * Tela de login da plataforma — Nexora Grid (frontend).
 *
 * Criado em: 16/10/2026 · Última modificação: 18/10/2026 · Versão: 1.1.0
 *
 * RF-09: "Esqueci minha senha" pede o link de redefinição por e-mail (`ContaEmail.tsx`).
 */
import { useState, type FormEvent } from "react";
import { ErroApi } from "../api";
import { useSessao } from "../sessao";
import { RecuperarSenha } from "./ContaEmail";
import { TituloMarca } from "../marca";

export function Login() {
  const { entrar, aviso } = useSessao();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [esperando, setEsperando] = useState(false);
  const [recuperando, setRecuperando] = useState(false);
  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    setEsperando(true);
    try {
      await entrar(login.trim().toLowerCase(), senha);
    } catch (falha) {
      setErro(falha instanceof ErroApi ? (falha.status === 423 ? "Conta bloqueada por tentativas inválidas. Aguarde e tente de novo."
        : falha.status === 401 ? "Login ou senha incorretos." : falha.message) : "Backend indisponível.");
    } finally {
      setEsperando(false);
    }
  };
  if (recuperando) {
    return (
      <div className="nx-tela tela-login" data-tema="cco">
        <div className="nx-cartao cartao-login">
          <TituloMarca />
          <RecuperarSenha voltar={() => setRecuperando(false)} />
        </div>
      </div>
    );
  }
  return (
    <div className="nx-tela tela-login" data-tema="cco">
      <form className="nx-cartao cartao-login" onSubmit={enviar} aria-label="Entrar">
        <TituloMarca />
        <p className="nx-suave">Centro de Controle Operacional</p>
        {aviso && <p className="aviso" role="status">{aviso}</p>}
        <div className="nx-campo" data-obrigatorio>
          <label htmlFor="login">Login</label>
          <input id="login" autoComplete="username" value={login} onChange={(e) => setLogin(e.target.value)} required />
        </div>
        <div className="nx-campo" data-obrigatorio>
          <label htmlFor="senha">Senha</label>
          <input id="senha" type="password" autoComplete="current-password" value={senha}
            onChange={(e) => setSenha(e.target.value)} required />
        </div>
        {erro && <p className="erro" role="alert">{erro}</p>}
        <button type="submit" className="nx-botao nx-botao-principal" disabled={esperando}>{esperando ? "Entrando…" : "Entrar"}</button>
        <button type="button" className="link-esqueci" onClick={() => setRecuperando(true)}>Esqueci minha senha</button>
      </form>
    </div>
  );
}
